import { Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from '../pages/login/login.page';
import { HomePage } from '../pages/home/home.page';
import { SaquesPage } from '../pages/saques/saques.page';
import { UsuariosPage } from '../pages/admin/usuarios/usuarios.page';
import { ClientesPage } from '../pages/clientes/clientes.page';
import { ClienteDetailPage } from '../pages/clientes/cliente-detail/cliente-detail.page';
import { AvisosPage } from '../pages/avisos/avisos.page';
import { AuthLayout } from '../layouts/auth-layout';
import { AuthenticatedLayout } from '../layouts/authenticated-layout';
import { PrivateRoute } from './private-route';
import { PublicRoute } from './public-route';
import { RequirePermission } from './require-permission';

export const AppRoutes = () => (
  <Routes>
    <Route element={<PublicRoute />}>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
    </Route>

    <Route element={<PrivateRoute />}>
      <Route element={<AuthenticatedLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/saques"
          element={
            <RequirePermission feature="SAQUE_READ">
              <SaquesPage />
            </RequirePermission>
          }
        />
        <Route
          path="/admin/usuarios"
          element={
            <RequirePermission feature="USER_READ">
              <UsuariosPage />
            </RequirePermission>
          }
        />
        <Route
          path="/clientes"
          element={
            <RequirePermission feature="CLIENTE_READ">
              <ClientesPage />
            </RequirePermission>
          }
        />
        <Route
          path="/clientes/:id"
          element={
            <RequirePermission feature="CLIENTE_DETAIL">
              <ClienteDetailPage />
            </RequirePermission>
          }
        />
        <Route
          path="/avisos"
          element={
            <RequirePermission feature="AVISO_READ">
              <AvisosPage />
            </RequirePermission>
          }
        />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);
